import { memoizedGet as get, Dict } from '@chakra-ui/utils'

/**
 * Very basic implementation of conversion of HEX to RGB do not use for precise handling.
 */
export function convertHextoRGBColor(hexColor: string) {
  const match = hexColor.match(/.{1,2}/g)

  if (!match) return null

  const aRgb = [
    parseInt(match[0], 16),
    parseInt(match[1], 16),
    parseInt(match[2], 16)
  ]

  return aRgb
}

/**
 * Basic Typescript condition assertion for narrowing types.
 *
 * @see https://exploringjs.com/tackling-ts/ch_type-guards-assertion-functions.html#asserting-a-boolean-argument-asserts-cond
 */
export function assert(
  condition: any,
  msg?: string
): asserts condition {
  if (!condition) {
    throw new Error(msg)
  }
}

/**
 * A helper to replace the depreciated Chakra getColor function.
 * Just does basic defined check validation, look to adding TinyColor package back for more validation scenarios.
 */
export function getColor(theme: Dict, color: string, fallback?: string) {
  const hex = get(theme, `colors.${color}`, color)

  return typeof hex === 'undefined' ? fallback : hex
}

/**
 * Helper to handle a string which is supposed to be a boolean or undefined, where
 * undefined will be false.
 */
export function assignStringBoolean(value?: unknown): boolean {
  return typeof value === 'boolean' ? value : false
}

/**
 * Helper to handle a string which is supposed to be a boolean or undefined, where
 * undefined will be false.
 */
export function isDefined<TValue>(value: unknown): value is TValue {
  return value !== null && value !== undefined
}
